import React, { useState, useEffect, useMemo } from 'react';
import { Popover, Input, Table } from 'antd';

export default (props) => {
  const {
    columns = [],
    onChange,
    multiple = false,
    disabled = false,
    placeholder = '请选择',
    showColumns = [],
    overLayWidth = 600,
    rowKey,
    tableProps = {},
    ref,
    dataSource = [],
  } = props;
  const [inputValue, setInputValue] = useState('');
  const [visible, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowsKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const onSelectionChange = (selectedRowKeys, selectedRows) => {
    setSelectedRows(selectedRows);
    setSelectedRowsKeys(selectedRowKeys);
    if (onChange) {
      onChange(selectedRows);
    }
    setInputValue(selectedRows.map((v) => v[showColumns]).toString());
    setVisible(false);
  };

  useEffect(() => {
    if (!inputValue) {
      setSelectedRowsKeys([]);
    }
  }, [inputValue]);

  const getInputValue = (value, showColumns) => {
    let inputValue = '';
    if (showColumns.length > 0) {
      showColumns.forEach((i) => {
        inputValue = `${value[i]}`;
      });
    }
    return inputValue;
  };

  const tableConfig = useMemo(() => {
    return {
      ...tableProps,
      rowKey: rowKey,
      size: 'small',
      columns: columns,
      dataSource: dataSource,
      rowSelection: multiple
        ? {
            type: 'checkbox',
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectionChange,
          }
        : {
            type: 'radio',
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectionChange,
          },
      onRow: (record) => {
        return {
          onClick: () => {
            if (record) {
              let value = getInputValue(record, showColumns);
              setInputValue(value);
              setVisible(false);
              setSelectedRowsKeys([record.key]);
              if (onChange) {
                onChange([record]);
              }
            }
          },
        };
      },
      pagination: false,
    };
  }, [inputValue, dataSource]);

  const renderContent = () => {
    return (
      <>
        <Table {...tableConfig} />
      </>
    );
  };

  const handleChange = (e) => {
    e.persist();
    if (e.target.value === '') {
      setInputValue('');
      setSelectedRowsKeys([]);
      if (onChange) {
        onChange([]);
      }
    } else {
      if (!visible) {
        setVisible(true);
      }
      setInputValue(e.target.value);
    }
  };
  const handleFocus = () => {
    setVisible(true);
  };

  const handleVisible = (visible) => {
    setVisible(visible);
  };

  return (
    <Popover
      placement="bottomLeft"
      visible={visible}
      content={renderContent()}
      trigger="click"
      overlayStyle={{ width: overLayWidth }}
      onVisibleChange={handleVisible}
    >
      <Input
        ref={ref}
        disabled={disabled}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        allowClear
        onClick={handleFocus}
        readOnly
      />
    </Popover>
  );
};
